export const ALLOW_ACCESS_INSTANCE = "AllowAccessInstanceId";

export const USERS_GROUP_ID = "users-0a3f6b6cc9d1";
export const PROFILES_GROUP_ID = "profiles-0a3f6b6cc9d1";
